// extracted by mini-css-extract-plugin
module.exports = {"filterSpinner":"Report_filterSpinner__2YOYN"};